export default {

    /* empresa */
    async listaEmpresa({commit, getters, rootState})
	{
        let usuario = JSON.parse(sessionStorage.getItem("user"))
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.get(`loginServer/empresas/${usuario.empresa_id}`, token)
        commit('SET_EMPRESA', data)

        return await data

    },

    async alteraEmpresa({commit, getters, rootState}, empresa)
    {
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.put(`loginServer/empresas`, empresa, token)

        return await data
    },


    /* usuário */
    async listaUsuario({commit, getters, rootState})
    {
        let usuario = JSON.parse(sessionStorage.getItem("user"))
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.get(`loginServer/usuarios/${usuario.empresa_id}`, token)
        commit('SET_USUARIOS', data)
        return await data
    },

    async alteraUsuario({commit, getters, rootState}, usuario)
    {
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.put(`loginServer/usuarios`, usuario, token)

        return await data
    },

    async sendDadosContato ({getters}, user) {
        let {data} = getters.getApi('/')
    },

    async sendValidaTelefone ({getters}, usuario) {
        let {data} = await getters.getApi.post("user/validaTelefone", usuario)
        return data
    },

    async cadastraUsuario({getters}, usuario)
    {
        let {data} = await getters.getApi.post("user", usuario)
        return await data
    },

    /* permissões */
    async listaPermissoes({commit, getters, rootState})
    {
        let token = rootState.system.token
        let usuario = JSON.parse(sessionStorage.getItem("user"))
        let {data} = await rootState.system.$barramento.get(`loginServer/getplano/${usuario.empresa_id}/${rootState.system.app_id}`, token)
        commit('SET_PERMISSOES', data.permissoes)

        return await data
    },

    async listaGrupos({commit, getters, rootState})
    {
        let usuario = JSON.parse(sessionStorage.getItem("user"))

        let token = rootState.system.token

        let id    = rootState.system.app_id

        let {data} = await rootState.system.$barramento.get(`loginServer/grupos/${usuario.empresa_id}/${rootState.system.app_id}`, token)
        commit('SET_GRUPOS', data)

        return await data
    },

    async cadastraGrupo({commit, getters, rootState}, paginas)
    {
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.post(`loginServer/grupos`, paginas, token)

        return await data
    },

    async alteraGrupo({commit, getters, rootState}, paginas)
    {
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.put(`loginServer/grupos`, paginas, token)

        return await data
    },

    async deletaGrupo({commit, getters, rootState}, grupo)
    {
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.delete(`loginServer/grupos/${grupo._id}`, token)

        return await data
    },

    async listaRotasWhatsapp({ rootState }, email)
    {
        try {
            const { data: empresa } = await rootState.system.$barramento.get(`loginServer/empresas/me/${email}`)
            return { status: true, empresa }
        } catch (err) {
            return { status: false }
        }
    },

    async updateWhatsappIntegration({ getters }, obj)
    {
        try {
            const { data } = await getters.getApi.put("user/update-whatsapp-integration", obj)
            return data
        } catch (err) {
            return { status: false, message: 'Não foi possível atualizar!' }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/usuario/actions.js